import { getRequest, postRequest } from "../requests";

interface MfaSettingsResponse {
    IsTotpEnabled: boolean;
    PasskeyServerBaseUrl?: string;
}

export async function getMfaSettings(): Promise<MfaSettingsResponse> {
    try {
        return await getRequest("api/user-applications/profile/MfaSettings");
    } catch (error) {
        throw Error("designer-login-error-get-mfa-settings-failed", { cause: error });
    }
}

export async function enableTotp(key: string, confirmationCode: string) {
  try {
    const response = await postRequest("api/user-applications/profile/EnableTotp", {
      key,
      confirmationCode
    })
    return response
  } catch (error) {
    throw Error("designer-login-error-enable-totp-failed", { cause: error })
  }
}

export async function disableTotp() {
  try {
    await postRequest("api/user-applications/profile/DisableTotp", {})
  } catch (error) {
    throw Error("designer-login-error-disable-totp-failed", { cause: error })
  }
}

export async function generateTotpKey() {
  try {
    const response = await postRequest("api/user-applications/profile/GenerateTotpKey", {})
    return response
  } catch (error) {
    throw Error("designer-login-error-generate-totp-key-failed", { cause: error })
  }
}

export async function generateRecoveryCodes() {
  try {
    const response = await postRequest("UserProfile/GenerateRecoveryCodes", {})
    return response
  } catch (error) {
    throw Error("designer-login-error-generate-recovery-codes-failed", { cause: error })
  }
}
